import React from 'react';

export default function ToolLayout({ accent, title, titleAccent, description, children }) {
  return (
    <div className="min-h-screen bg-[#050505] text-white" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>
      <div className="border-b border-zinc-900 px-6 py-4 flex items-center justify-between">
        <a href="/#/tools" style={{ textDecoration: 'none' }} className="text-[11px] tracking-[0.2em] text-zinc-500 hover:text-sky-400 uppercase font-bold transition-colors">
          ← Aperture Slate Tools
        </a>
        <a href="/#/" style={{ textDecoration: 'none' }} className="text-[11px] tracking-[0.15em] text-zinc-700 hover:text-zinc-400 uppercase transition-colors">
          Main Site
        </a>
      </div>
      <div className="flex justify-center px-6 pt-10 pb-24">
        <div className="w-full max-w-2xl">
          <div className="mb-10">
            {accent && (
              <p className="text-[11px] tracking-[0.35em] text-sky-400 font-bold uppercase mb-3">
                {accent}
              </p>
            )}
            <h1 className="text-5xl font-black tracking-tight uppercase leading-none">{title}</h1>
            {titleAccent && (
              <h1 className="text-5xl font-black tracking-tight uppercase leading-none text-zinc-600">{titleAccent}</h1>
            )}
            {description && (
              <p className="text-zinc-500 text-sm mt-5 leading-relaxed max-w-md">{description}</p>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
